import SyncableModel from './SyncableModel';

export default class Widget extends SyncableModel {
  static name = 'Widget'

  _fillable = [
    "id",
    "code",
    "title",
    "link",
    "target_url",
    "height_in_pixel",
    "number",
  ]

  incrementing = false

  static syncOnly = true

  static hasSyncedAt = false

  _casts = {
    height_in_pixel: "integer",
    number: "integer",
  }

  static endpoint = '/widgets'

  static online = true
}
